class RecentlyViewed extends HTMLElement {
  constructor(){
    super();

    this.sectionId = this.dataset.sectionId;
    this.outputContainer = this.querySelector('.recently-viewed-container');
    this.options = this.dataset.options;

    this.init();
  }

  async init() {
    const promises = Object.keys(theme.recentlyViewed.recent).reduce((acc, handle) => {
      if (handle !== 'undefined') {
        return [...acc, this.getProductInfo(handle)];
      }
      return acc;
    }, []);

    try {
      const results = await Promise.all(promises);
      this.renderOutput(results);
      this.captureProductDetails(results);
    } catch (error) {
      console.log(error)
    }

    this.slider = this.querySelector('css-slider');
    this.slider.resetSlider();
  }

  getProductInfo(handle) {
    return new Promise(function(resolve, reject) {
      if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
        resolve(theme.recentlyViewed.productInfo[handle]);
      } else {
        fetch(`/products/${handle}?view=ajax`).then(function(response) {
          return response.json();
        }).then(function(product) {
          resolve(product);
        });
      }
    });
  }

  _formatMoney(cents, format) {

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);

  }

  renderOutput(products) {
    // Hide section if empty
    if (!products.length || !this.outputContainer) {
      this.classList.add('hide');
    }

    const buildProductGridItem = () => {
      return products.map((product) => {
        const fav = product.variants.find(({available}) => available);
        const hasSecondaryImg = product.media.length > 1;
        const onSale = product.compare_at_price > product.price;
        const hasBgColor = product.tags.find((tag) => tag.startsWith('_bgcolor_'));
        const hasBorderColor = product.tags.find((tag) => tag.startsWith('_bordercolor_'));

        const buildMedia = () => {
          const buildImg = (img, type) => {
            return `
              <figure class="lazy-image product-item__image-figure product-item__image-figure--${type} lazy-image--animation lazy-image--background lazyloaded" data-ratio="1" style="padding-top: 100%" data-crop="false">
                <img src="https:${img.src}width=480" alt="${img.alt ?? product.title}" class="img" width="400" height="400" data-ratio="1" loading="lazy" onload="this.parentNode.classList.add('lazyloaded')">
              </figure>
            `;
          }
          const buildVideo = (video) => {
            return `
              <video playsinline autoplay loop muted>
                <source src="${video.url}" type="${video.type}">
              </video>
            `;
          }

          let markup = '';
          const [ firstMedia ] = product.media;
          if (firstMedia.media_type === 'video') {
            const videoSrc = firstMedia.sources.find(({format}) => format === 'mp4');
            markup = buildVideo(videoSrc);
          } else {
            markup = buildImg(firstMedia, 'primary');
          }

          if (hasSecondaryImg) {
            markup += buildImg(product.media[1], 'secondary');
          }
          return markup;
        }

        return `
          <div id="product-item-${product.id}" class="product-item card${hasBgColor ? ' has-bg-color' : ''}${hasBorderColor ? ' has-border-color' : ''}" data-js-product-item style="${hasBgColor ? `--bgColor: ${hasBgColor.replace('_bgcolor_', '')};` : ''}${hasBorderColor ? ` --borderColor: ${hasBorderColor.replace('_bordercolor_', '')};` : ''}">
            <a href="/products/${product.handle}" class="card__image product-item__image${hasSecondaryImg ? ' product-item__image--has-secondary' : ''}" style="padding-top: 100%">
              ${buildMedia()}
            </a>
            <div class="card__text product-item__text gutter--regular spacing--xlarge remove-empty-space text-align--left">
              <div class="product-item__vendor text-size--large text-color--opacity equalize-white-space">
                <div class="remove-line-height-space">${product.vendor}</div>
              </div>

              <a class="product-item__title" href="/products/${product.handle}" title="${product,this.title}">
                <div class="remove-line-height-space--small">
                  <span class="text-animation--underline text-size--large text-line-height--small text-weight--bold text-animation--underline">${product.title}</span>
                </div>
              </a>

              <div class="product-item__ratings">
                <div class="star-rating" aria-label="">
                  <span class="visually-hidden">No reviews</span>
                  <span class="star-rating__stars" style="width:100px;">
                    <span class="star-rating__stars-active" style="width:0%"></span>
                  </span>
                  <span class="star-rating__caption text-size--xsmall  palm-hide ">No reviews</span>
                </div>
              </div>

              <div class="custom-html">
                ${product.metafields.custom.serves_amount ? `<span class="metafield-single_line_text_field">Serves ${product.metafields.custom.serves_amount}</span>` : ''}
                ${fav.metafields.custom.minimum_quantity ? `<span class="metafield-single_line_text_field">MOQ ${fav.metafields.custom.minimum_quantity}</span>` : ''}
              </div>

              <div class="product-item__price text-size--large equalize-white-space">
                <div class="remove-line-height-space">
                  <div class="product-price">
                    <span class="product-price--original " data-js-product-price-original="${this._formatMoney(product.price, KROWN.settings.shop_money_format)}">${this._formatMoney(product.price, KROWN.settings.shop_money_format)}</span>
                    <del class="product-price--compare" data-js-product-price-compare="${product.compare_at_price ? this._formatMoney(product.compare_at_price, KROWN.settings.shop_money_format) : ''}">${product.compare_at_price ? this._formatMoney(product.compare_at_price, KROWN.settings.shop_money_format) : ''}</del>
                    <span class="product-price--unit text-size--regular" data-js-product-price-unit=""></span>
                  </div>
                </div>
              </div>

              ${product.metafields.custom.promo_text ? `<div class="product-item__text text-size--regular text-line-height--medium equalize-white-space promo-text" style="color: #424242;">${product.metafields.custom.promo_text}</div>` : ''}
            </div>

            <div class="product-item__text product-item__button-wrap gutter--regular spacing--xlarge remove-empty-space text-align--left">
              <div class="product-item__quick-buy">
                ${
                  product.variants.length === 1 ?
                  `
                    <quick-add-to-cart class="quick-add-to-cart">
                      <product-form data-ajax-cart>
                        <div class="quick-add-to-cart-button">
                          ${
                            fav.metafields.custom.minimum_quantity ?
                            `
                              <product-moq>
                                <div class="button faux-button button--outline button--regular button--fullwidth">
                                  <span class="button__text no-events">${theme.strings.quickBuy}</span>
                                </div>
                                <div class="product-quantity button--loader is-hidden" data-min="${fav.metafields.custom.minimum_quantity}" data-inventory='{ "management": "${fav.inventory_management}", "policy": "${fav.inventory_policy}", "quantity": "${fav.inventory_quantity}" }'>
                                  <span class="product-quantity__minus qty-minus">
                                    <svg class="no-events" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V7H0L1.19209e-07 5L12 5Z" fill="black" style="stroke:none"></path></svg>
                                  </span>
                                  <span class="button__text button--regular">Add ${fav.metafields.custom.minimum_quantity}</span>
                                  <span class="button__preloader">
                                    <svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"/></svg>
                                  </span>
                                  <span class="product-quantity__plus qty-plus">
                                    <svg class="no-events" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 0H7V12H5V0Z" fill="black" style="stroke:none"></path><path d="M12 5V7H0L1.19209e-07 5L12 5Z" fill="black" style="stroke:none"></path></svg>
                                  </span>
                                </div>
                              </product-moq>
                            `
                            : ''
                          }
                          <form method="post" action="/cart/add" id="product_form_${product.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
                            <input type="hidden" name="form_type" value="product">
                            <input type="hidden" name="utf8" value="✓">
                            <input type="hidden" name="id" value="${fav.id}">
                            ${fav.metafields.custom.minimum_quantity ? `<input type="hidden" name="quantity" value="${fav.metafields.custom.minimum_quantity}">` : ''}
                            <button class="button button--outline button--regular button--fullwidth button--loader" data-js-product-add-to-cart type="submit" name="add">
                              <span class="button__text ">Add to cart</span>
                              <span class="button__preloader">
                                <svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"></circle></svg>
                              </span>
                            </button>
                          </form>
                        </div>
                      </product-form>
                    </quick-add-to-cart>
                  ` :
                  `
                    <quick-view-product class="quick-add-to-cart">
                      <a href="/products/${product.handle}" class="button button--outline button--regular button--fullwidth button--loader" data-js-product-add-to-cart data-id="${product.id}">
                        <span class="button__text">${theme.strings.quickBuy}</span>
                        <span class="button__preloader">
                          <svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"/></svg>
                        </span>
                      </a>
                    </quick-view-product>
                  `
                }
              </div>
            </div>

            <div class="product-item__badges text-size--regular">
              ${
                !product.available ?
                `<span class="product-item__badge product-item__badge--sold" style="background-color: #d9d9d9; color: #424242">Sold Out</span>` :
                onSale ?
                `<span class="product-item__badge product-item__badge--sale" style="background-color: #fcc9cc; color: #424242">On Sale</span>` : ''
              }
              <button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${product.id}" data-swaction="addToWishlist" data-product-id="${product.id}" data-variant-id="${fav.id}" data-product-url="${theme.routes.shopUrl}${theme.routes.rootUrl}products/${product.handle}"></button>
            </div>

          </div>
        `
      }).join('');
    }

    const container = document.createElement('div');
    container.innerHTML = `
      <css-slider id="css-slider-${this.sectionId}" class="css-slider css-slider--middle-navigation css-slider--hide-dots css-slider--hide-indexnav" data-options='${this.options}'>
        <div class="grid grid--slider grid-4 grid-portable-3 grid-lap-2 grid-tiny-1">${buildProductGridItem()}</div>
      </css-slider>
    `;

    this.outputContainer.appendChild(container);

    document.dispatchEvent(new CustomEvent('recentlyViewed:loaded'));
  }

  captureProductDetails(products) {
    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      theme.recentlyViewed.productInfo[product.handle] = product;
    }

    window.sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
  }
}
if (!customElements.get('recently-viewed')){
  customElements.define('recently-viewed', RecentlyViewed);
}